import { showErrorResponse } from "../../app/utils/common/Functions";
import { showSuccessToast } from "../../app/utils/common/Toast";
import { createRoleAPI, deleteRoleAPI, editRoleAPI, getAllRoleModulesAPI, getAllRolesAPI } from "../Apis/roleApi";

export const roleReducer = (builder) => {
    builder
        .addCase(getAllRolesAPI.pending, (state) => {
            state.loading = true;

        })
        .addCase(getAllRolesAPI.fulfilled, (state, action) => {
            state.loading = false;
            state.roles = action.payload.data;
            state.isRoleUpdated = false;

        })
        .addCase(getAllRolesAPI.rejected, (state, action) => {
            showErrorResponse(action.payload);
        })
        .addCase(getAllRoleModulesAPI.pending, (state) => {
            state.moduleLoading = true;

        })
        .addCase(getAllRoleModulesAPI.fulfilled, (state, action) => {
            state.moduleLoading = false;
            state.modules = action.payload.data;
        })
        .addCase(getAllRoleModulesAPI.rejected, (state, action) => {
            state.moduleLoading = false;
            showErrorResponse(action.payload);
        })
        .addCase(createRoleAPI.pending, (state) => {
            state.loading = true;

        })
        .addCase(createRoleAPI.fulfilled, (state, action) => {
            state.loading = false;
            state.isRoleUpdated = true;
            state.roles=[];
            showSuccessToast("Role created successfully");
        })
        .addCase(createRoleAPI.rejected, (state, action) => {
            state.loading = false;
            showErrorResponse(action.payload);
        })
        .addCase(editRoleAPI.pending, (state) => {
            state.loading = true;

        })
        .addCase(editRoleAPI.fulfilled, (state, action) => {
            state.loading = false;
            state.isRoleUpdated = true;
            state.roles=[];
            showSuccessToast("Role updates successfully");
        })
        .addCase(editRoleAPI.rejected, (state, action) => {
            state.loading = false;
            showErrorResponse(action.payload);
        })
        .addCase(deleteRoleAPI.pending, (state) => {
            state.loading = true;

        })
        .addCase(deleteRoleAPI.fulfilled, (state, action) => {
            state.loading = false;
            state.roles=[];
            state.isRoleUpdated = true;
        })
        .addCase(deleteRoleAPI.rejected, (state, action) => {
            state.loading = false;
            showErrorResponse(action.payload);
        })

};
